import { mapMutations, mapState, mapActions } from 'vuex'
import {
  genericGetRequestToApi,
  genericPutRequestToApi
} from '../../utils/genericRequests'
import { RetrieveProfileUrl } from '../../utils/agentUrls'
import { isEmpty } from '../../utils/generalUtils'
import { createFavoriteProperty } from '../../services/propertiesService'
import { UpdateDeleteFavoriteUrl } from '../../utils/clientUrls'

export default {
  data() {
    return {
      isAssignProgress: false
    }
  },

  computed: {
    ...mapState('agent', ['agentData', 'rhtValue']),
    ...mapState('client', ['clientData', 'clientFavorites'])
  },

  methods: {
    ...mapActions('common', ['getRouteData', 'profileLogout']),
    ...mapActions('agent', [
      'fetchAgentMessagesAction',
      'agentRouteDataAction',
      'loadRequestedHomeData',
      'updatePropertyStates'
    ]),
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    ...mapMutations('common', {
      setLoadingRoutes: 'SET_LOADING_ROUTES'
    }),

    async getAgentData(loadRoutes = true) {
      this.setLoadingRoutes(true)
      const response = await genericGetRequestToApi(RetrieveProfileUrl())
      if (response.status === 200) {
        this.fetchAgentMessagesAction()
        this.setAgentData(response.data)
        if (loadRoutes) {
          this.agentRouteDataAction(response.data)
        }

        if (!isEmpty(this.clientData)) {
          const updatedClient = response.data.clients.find(
            client => client._id === this.clientData._id
          )
          this.setClientData(updatedClient)
        }

        if (!isEmpty(response.data.clients) && loadRoutes) {
          if (!isEmpty(this.clientData)) {
            const updatedClient = response.data.clients.find(
              client => client._id === this.clientData._id
            )
            this.getRouteData({ data: updatedClient, type: 'client' })
          } else {
            this.getRouteData({ data: response.data, type: 'agent' })
          }
        }
      } else if (response.status === 401) {
        this.profileLogout()
      }
    },

    /**
     * Handles click on Save for a particular property
     * Assigns the property to the selected client by an agent
     *
     * @public
     */
    async assignPropertyToClient(propertyObject, selectedClient) {
      this.isAssignProgress = true
      const response = await createFavoriteProperty(
        selectedClient._id,
        propertyObject._id
      )
      if (response.status === 201) {
        if (this.agentData && this.agentData.clients) {
          this.updateAgentOnAssignOrRequest(selectedClient, response.data)
        }
      } else if (response.status === 409) {
        // Include some warnings messages through component
        console.log('already assigned')
      }
      this.isAssignProgress = false
    },

    async requestTourForClient(propertyObject, selectedClient) {
      this.isAssignProgress = true
      const clientHomes = selectedClient.homes
      let favObject = null
      favObject = clientHomes.find(
        home => home.propertyId === propertyObject._id
      )
      if (!clientHomes || isEmpty(favObject)) {
        favObject = (
          await createFavoriteProperty(selectedClient._id, propertyObject._id)
        ).data
      }

      if (favObject) {
        const response = await genericPutRequestToApi(
          UpdateDeleteFavoriteUrl(selectedClient._id, favObject._id),
          null,
          {
            params: { requestTour: true }
          }
        )

        if (response.status === 200) {
          if (
            !isEmpty(this.clientData) &&
            this.clientData._id === selectedClient._id
          ) {
            const updatedRhtHomes = this.rhtValue.data
            const newRhtProperty = {
              ...propertyObject,
              ...response.data,
              favoriteId: response.data._id,
              _id: propertyObject._id
            }
            updatedRhtHomes.unshift(newRhtProperty)
            const updatedFavHomes = [...this.clientFavorites]
            updatedFavHomes.unshift(newRhtProperty)
            this.updatePropertyStates({ updatedRhtHomes, updatedFavHomes })
          }
          this.updateAgentOnAssignOrRequest(selectedClient, response.data)
        } else {
          console.log('some error occurred')
        }
      } else {
        console.log('some error occurred')
      }
      this.isAssignProgress = false
    },

    updateAgentOnAssignOrRequest(selectedClient, updatedProperty) {
      const updatedHomes = selectedClient.homes
      updatedHomes.unshift(updatedProperty)
      selectedClient = { ...selectedClient, homes: updatedHomes }
      const updatedClientData = this.agentData.clients.map(client => {
        if (client._id === selectedClient._id) {
          return selectedClient
        }
        return client
      })
      this.setAgentData({ ...this.agentData, clients: updatedClientData })
    }
  }
}
